// medicalServicesEvents.js — nomes dos eventos realtime MEDICAL_* que o
// frontend escuta. Espelha (nao importa, por nao poder importar codigo
// backend/Prisma para o bundle do navegador) EVENT_TYPES de
// src/backend/medicalServices/medicalEventService.js — mesma convencao ja
// usada por MASTER_PLAN_REVISION_PUBLISHED, redefinido como const local
// tanto em masterPlanRoutes.js (backend) quanto em MasterPlanCard.jsx
// (frontend). Se o backend adicionar/renomear um evento aqui, o par local
// correspondente precisa ser atualizado nos dois lados.
export const MEDICAL_EVENT_TYPES = Object.freeze([
  'MEDICAL_PROFILE_UPDATED',
  'MEDICAL_FACILITY_CREATED',
  'MEDICAL_FACILITY_STATUS_CHANGED',
  'MEDICAL_CAPACITY_UPDATED',
  'MEDICAL_PATIENT_REGISTERED',
  'MEDICAL_TRIAGE_RECORDED',
  'MEDICAL_PATIENT_STATUS_CHANGED',
  'MEDICAL_TREATMENT_EPISODE_UPDATED',
  'MEDICAL_TRANSPORT_REQUESTED',
  'MEDICAL_TRANSPORT_STATUS_CHANGED',
  'MEDICAL_DESTINATION_ACCEPTED',
  'MEDICAL_PATIENT_RECEIVED',
  'MEDICAL_AGENCY_REQUEST_CREATED',
  'MEDICAL_AGENCY_REQUEST_STATUS_CHANGED',
  'MEDICAL_RESOURCE_REQUESTED',
  'MEDICAL_RESOURCE_REQUEST_STATUS_CHANGED',
  'MEDICAL_FATALITY_RECORDED',
  'MEDICAL_FATALITY_STATUS_CHANGED',
  'MEDICAL_OPERATIONAL_PHASE_CHANGED',
]);

export default MEDICAL_EVENT_TYPES;
